<template>
    <two-column-layout>
        <card-container>
            <h2>{{ $t(i18n.coverage_overview_step.title) }}</h2>
            <p>{{ $t(i18n.coverage_overview_step.description) }}</p>

            <list-group-fragment label="">
                <list-item-fragment
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_LIABILITY')"
                >
                    {{$t(i18n.coverage.liability_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(additionalRisks.legalAssistance)"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_LEGAL_ASSISTANCE')"
                >
                    {{$t(i18n.coverage.legal_assistance_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(additionalRisks.insureFinancialDamage)"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_DAMAGE')"
                >
                    {{$t(i18n.coverage.damage_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(companyProfile.buildingOwnership)"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_FIRE_DAMAGE_BUILDING')"
                >
                    {{$t(i18n.coverage.fire_damage_building_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(companyProfile.inventoryPresent) || companyProfile.valueTenantInterest > 0"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_FIRE_DAMAGE_INVENTORY_AND_GOODS')"
                >
                    {{$t(i18n.coverage.fire_damage_inventory_and_goods_label)}}
                </list-item-fragment>

                <list-item-fragment
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_CLIENT_OBJECTS')"
                >
                    {{$t(i18n.coverage.client_objects_label)}}
                </list-item-fragment>

                <list-item-fragment
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_LIABILITY_TRADESTOCK')"
                >
                    {{$t(i18n.coverage.liability_tradestock_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(companyProfile.tradestockPresent)"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_CASCO_ALLROUND_TRADESTOCK')"
                >
                    {{$t(i18n.coverage.casco_allround_tradestock_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(companyProfile.tradestockPresent)"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_PASSENGER_DAMAGE_TRADESTOCK')"
                >
                    {{$t(i18n.coverage.passenger_damage_tradestock_label)}}
                </list-item-fragment>

                <list-item-fragment
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_MONETARY_TRANSPORT')"
                >
                    {{$t(i18n.coverage.monetary_transport_label)}}
                </list-item-fragment>

                <list-item-fragment v-if="isFieldSelected(companyProfile.employees)"
                  show-info
                  @info-clicked="onInfoClicked('GPS_QUOTE_REQUEST_COVERAGE_PROPER_EMPLOYMENT')"
                >
                    {{$t(i18n.coverage.proper_employment_label)}}
                </list-item-fragment>
            </list-group-fragment>

        </card-container>
        <button-group direction="right" top-spacing="l">
            <button-fragment icon-before="back"
                             as-link
                             @click="previousStep()">{{$t(i18n.button.previous)}}
            </button-fragment>
            <button-fragment :disabled="finalizing" @click="submit()">{{$t(i18n.button.submit)}}</button-fragment>
        </button-group>
    </two-column-layout>
</template>

<script>
    import {Utils} from "@bvm/core";
    import {
        ListGroupFragment,
        ListItemFragment,
        TwoColumnLayout,
        ButtonFragment,
        ButtonGroup,
        CardContainer
    } from "@bvm/forms";
    import MediaItemModal from "../../shared/media-item-modal";
    import {createNamespacedHelpers} from "vuex";

    const { mapState } = createNamespacedHelpers(
      "gpsQuoteRequest"
    );

    const i18nBuilder = new Utils.I18n.I18nBuilder("gps_quote_request_form")
      .add("coverage_overview_step", b => b.add("title").add("description"))
      .add("button", b => b.add("previous").add("submit"))
      .add("coverage", b => b.add("liability_label")
        .add("legal_assistance_label")
        .add("damage_label")
        .add("fire_damage_building_label")
        .add("fire_damage_inventory_and_goods_label")
        .add("client_objects_label")
        .add("liability_tradestock_label")
        .add("casco_allround_tradestock_label")
        .add("passenger_damage_tradestock_label")
        .add("monetary_transport_label")
        .add("proper_employment_label"))

    export const messageKeys = i18nBuilder.getKeys();

    export default {
        name: "coverage-overview-step",
        components: {
            ListGroupFragment,
            ListItemFragment,
            TwoColumnLayout,
            ButtonFragment,
            ButtonGroup,
            CardContainer
        },
        props: {
            finalizing: { type: Boolean }
        },
        data() {
            return {
                i18n: i18nBuilder.getData()
            };
        },
        computed: {
            ...mapState(["companyProfile", "additionalRisks"])
        },
        methods: {
            isFieldSelected(fieldValue) {
                return fieldValue === 'y';
            },
            onInfoClicked(mediaItemTag) {
                this.$bvmModal.show(MediaItemModal, {
                    itemTag: mediaItemTag
                }, {
                    clickToClose: true
                });
            },
            previousStep(value) {
                this.$emit("previousStep", value);
            },
            submit() {
                if (!this.finalizing) {
                    this.$emit("submit");
                }
            }
        }
    }
</script>

<style>

</style>